import { useEffect, useState } from 'react';
import { IClientTripSearchFull } from '@bustickus/models-client';
import { StageError, StageFirst, StageLoading } from './components';
import { Box, Flex, Header } from 'components';
import './style.scss';
import { ApiTrips } from 'common/api';
import { TripList } from '..';

type Stage = 'first' | 'loading' | 'default' | 'error';

interface IProps {
  departureCityId: string | null;
  arrivalCityId: string | null;
  departureDate: Date | null;
  returnDate: Date | null;
}

function TripBlock(props: IProps) {
  const [stage, setStage] = useState<Stage>('first');
  const [trips, setTrips] = useState<IClientTripSearchFull | null>(null);

  useEffect(() => {
    loadTrips();
  }, [props.departureCityId, props.arrivalCityId, props.departureDate, props.returnDate]);

  const loadTrips = async () => {
    if (props.departureCityId == null || props.arrivalCityId == null || props.departureDate == null) {
      return;
    }

    try {
      setStage('loading');
      const apiTrips = ApiTrips.getInstance();
      const trips = await apiTrips.search(
        props.departureCityId,
        props.arrivalCityId,
        props.departureDate,
        props.returnDate
      );
      setTrips(trips);

      setStage('default');
    } catch {
      setStage('error');
    }
  };

  return (
    <>
      {stage !== 'default' && (
        <Box
          padding={20}
          className='trips-block-wnFW'
        >
          <Flex
            direction='column'
            gap={20}
            className='stage-XXPW'
          >
            <Header>Поиск рейсов</Header>
            {stage === 'first' && <StageFirst />}
            {stage === 'error' && <StageError />}
            {stage === 'loading' && <StageLoading />}
          </Flex>
        </Box>
      )}
      {stage === 'default' && (
        <TripList
          aCityId={props.arrivalCityId}
          dCityId={props.departureCityId}
          searchResult={trips}
        />
      )}
      <div className='filler-wj7' />
    </>
  );
}

export default TripBlock;
